<template>
  <div>
    <v-btn
      color="info"
      class="mt-4"
      id="hyperionUButton"
      href="https://knowledge.seerist.com/welcome/"
      target="_blank"
      v-on:click="storeMetric"
      >Seerist University
    </v-btn>
  </div>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "HyperionU",
  methods: {
    storeMetric() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.settings,
        EVENT_ACTIONS.clicked,
        "e-Learning"
      );
    },
  },
};
</script>
